import { createI18n } from 'vue-i18n';
import { messages, defaultLocale, Locales } from '@/locales';

const numberFormats = {
	[Locales.EN]: {
		currency: {
			style: 'currency', currency: 'USD', minimumFractionDigits: 0,
		},
	},
};
const datetimeFormats = {
	[Locales.EN]: {
		short: {
			year: 'numeric', month: 'short', day: 'numeric',
		},
		long: {
			year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
		},
	},
};

export const i18n = createI18n({
	legacy: false,
	locale: defaultLocale,
	messages,
	numberFormats,
	datetimeFormats,
});

export type I18n = typeof i18n;
